export default __webpack_public_path__ + "static/media/icon-completed.b8a3f9a6.svg";